import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchInterceptors } from "../../Api/fetchInterceptors";

const END_POINT_VERIFY_OTP =
  process.env.REACT_APP_END_POINT_VERIFY_OTP_FOR_UPDATE_EMAIL;

export const verifyOTP_ForUpdateUserEmail = createAsyncThunk(
  "verify/OTP/for/update/user/email",
  async (patchData, thunkAPI) => {
    try {
      const result = fetchInterceptors(
        END_POINT_VERIFY_OTP,
        "PATCH",
        patchData
      );
      return result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const verifyOTP_ForUpdateUserEmailSlice = createSlice({
  name: "verifyOTP_ForUpdateUserEmailSlice",
  initialState: {
    response: null,
    success: false,
    statusCode: null,
    error: null,
    loading: null,
  },
  reducers: {
    setDefault_Verify_OTP_EmailSate: (state) => {
      state.response = null;
      state.success = false;
      state.statusCode = null;
      state.error = null;
      state.loading = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyOTP_ForUpdateUserEmail.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyOTP_ForUpdateUserEmail.fulfilled, (state, action) => {
        if (action.payload?.success) {
          state.error = null;
          state.response = action.payload;
          state.success = action.payload?.success;
          state.statusCode = action.payload?.code;
          state.loading = false;
        } else {
          state.response = null;
          state.error = action.payload;
          state.success = action.payload?.success;
          state.statusCode = action.payload?.code;
          state.loading = false;
        }
      })
      .addCase(verifyOTP_ForUpdateUserEmail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setDefault_Verify_OTP_EmailSate } =
  verifyOTP_ForUpdateUserEmailSlice.actions;

export default verifyOTP_ForUpdateUserEmailSlice.reducer;
